module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "line"
  }, [_vm._v("Acknoledgements")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many thanks to my readers Ellen Milmed, Tiina Lombard, Edward Glenn, Jason Murray, William Durnell, and Kevin Eady, to my editor Ibrahim Ahmad, to my publisher Johnny Temple, to my agent Eleanor Jackson, and to the Earth Ethics Institute at Miami Dade College, whose class in the swamps inspired this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Much props, all.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c560b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 72
// module chunks = 0